import { useEffect, useState } from 'react';
import AnalystForecasts from '../components/forecast/AnalystForecasts';
import { Table, UserCircle2 } from 'lucide-react';
import { ScenarioEditor } from '../components/forecast/ScenarioEditor';
import { useLocation, useParams } from 'react-router-dom';
import Analytics from '../services/analytics';

export function Forecast() {
  const [activeTab, setActiveTab] = useState<'analyst' | 'me'>('analyst');
  const location = useLocation();
  const { symbol, subsection } = useParams();

  // Handle URL path (Best for SEO/Ads): /GME/forecast/user
  useEffect(() => {
    if (subsection === 'user' || subsection === 'me') {
      setActiveTab('me');
    }
  }, [subsection]);

  // Track ViewContent when "By Me" tab is active
  useEffect(() => {
    if (activeTab === 'me' && symbol) {
      Analytics.event('ViewContent', {
        content_type: 'product',
        content_ids: [symbol],
        content_name: `${symbol} User Forecast`,
        content_category: 'Forecast Tool'
      });
    }
  }, [activeTab, symbol]);

  // Sync tab with URL so we can deep-link to "By Me" using ?tab=me or #me
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = (params.get('tab') || location.hash.replace('#', '')).toLowerCase();
    if (tabParam === 'me') setActiveTab('me');
    if (tabParam === 'analyst') setActiveTab('analyst');
  }, [location.search, location.hash]);

  return <div className="w-full mx-auto">
    {/* Compact segmented control for Company/Me without extra container */}
    {/* ============================================
        FEATURE CHANGE: Renamed "By Analyst" to "By Company"
        Date changed: January 23, 2026
        ============================================ */}
    <div className="mx-2 mb-3">
      <div role="tablist" aria-label="Forecast View" className="mt-2 inline-flex items-stretch rounded-md overflow-hidden">
        <button
          role="tab"
          aria-selected={activeTab === 'analyst'}
          onClick={() => setActiveTab('analyst')}
          className={`flex items-center px-3 py-1.5 text-xs font-medium transition-colors focus:outline-none mr-2 btn ${activeTab === 'analyst'
            ? 'active'
            : ''
            }`}
        >
          <Table size={12} className="mr-1.5" />
          By Company
        </button>
        <button
          role="tab"
          aria-selected={activeTab === 'me'}
          onClick={() => setActiveTab('me')}
          className={`flex items-center px-3 py-1.5 text-xs font-medium transition-colors border-l border-theme-tertiary focus:outline-none btn ${activeTab === 'me'
            ? 'active'
            : ''
            }`}
        >
          <UserCircle2 size={12} className="mr-1.5" />
          By Me
        </button>
      </div>
    </div>
    {activeTab === 'analyst' ? <AnalystForecasts /> : <ScenarioEditor />}
  </div>;
}